import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isEmpty } from 'underscore';
import { Spinner } from 'reactstrap';

import { ROUTES, APP_CURRENCY_NAME, TRADE_IN_DEVICES, STORAGEKEY_TRADE_IN_DEVICE } from 'config/constants';

import { notifType, notify } from 'utils/notifSender';
import CheckoutPaymentInfo from 'layouts/CartLayout/CheckoutPaymentInfo/CheckoutPaymentInfo';

import { checkoutRules } from 'api/cart';
import { getAuthedProfile } from 'api/user';
import { trackKlaviyoEvent } from 'api/tracking';

import {
    handleSupportDocsUpload,
    updatedOnSupportUploadedEvent,
    handleGuarantorInformationUpdate,
    guarantorInformationFromStateToStore,
    updateSupportingDocumentsDatFromStateToStore
} from 'redux/reducers/user';
import { handleRemoveCartItem } from 'redux/reducers/cart';
import { triggerOrderPlacingEventFromOutside } from 'redux/reducers/order';

import { getStorageAttribute } from 'utils/helpers';

const ToProceed = ({ products, userCart, hideBottomCTABtns, cartStickyBottomExpanded, submitCoupon, coupon, setCoupon, handleSubmit, order, orderExist, type, Loading, onClick = () => { } }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const cartLocalStorageJSON = localStorage.getItem('products');
    const cartLocalStorage = cartLocalStorageJSON ? JSON.parse(cartLocalStorageJSON) : [];
    const [triggerPlaceOrderEvent, setTriggerPlaceOrderEvent] = useState(false);
    const [triggeringThePlaceOrderButtonEvent, setTriggeringThePlaceOrderButtonEvent] = useState(false);
    const [currentCartItemPricingObjLocalStorage, setCurrentCartItemPricingObjLocalStorage] = useState({});
    const emptyCart = !(products?.length > 0 || cartLocalStorage?.length > 0);
    const { isAuthed } = useSelector(state => ({ isAuthed: state.auth.isAuthed }));
    const { isVerified } = useSelector(state => ({ isVerified: state.auth.profile.singpass_status === 'verified' }));
    const { supportingDocs, supportingDocsUploaded } = useSelector(state => ({
        supportingDocs: state.user.supportingDocs,
        supportingDocsUploaded: state.user.supportingDocsUploaded
    }));
    const { orderPlaced } = useSelector(state => ({ orderPlaced: state.order.orderPlaced }));
    const { guarantor } = useSelector(state => ({ guarantor: state.user.guarantor }));
    const { profile } = useSelector(state => ({ profile: state?.auth?.profile }));
    const { orderPlacementPageTermsAndCondition } = useSelector(state => ({
        orderPlacementPageTermsAndCondition: state.order.orderPlacementPageTermsAndCondition,
        canProceedToOrderPlacement: state.order.canProceedToOrderPlacement
    }));
    const { selectedCartItem, currentCartItemPricingObj, cartProducts, meta } = useSelector(state => ({
        selectedCartItem: state.cart.selectedCartItem,
        currentCartItemPricingObj: state.cart.currentCartItemPricingObj,
        cartProducts: state.cart.fetchedProducts,
        meta: state.cart.overview
    }));
    const { segment } = useSelector(state => ({ segment: state.common.segment }));
    const segmentQuery = segment ? `?segment=${segment}` : '';
    const [couponAmount, setCouponAmount] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [isExtraMonthPromo, setIsExtraMonthPromo] = useState(false);
    const [selectedTradeIn, setSelectedTradeIn] = useState(null);

    const [productName, setProductName] = useState(null);
    const [productCategory, setProductCategory] = useState(null);
    const [productColor, setProductColor] = useState(null);
    const [productStorage, setProductStorage] = useState(null);
    const [productRetailValue, setProductRetailValue] = useState(null);
    const { selectedMethodId } = useSelector((state) => ({
        selectedMethodId: state.payment.selectedPaymentMethodId
    }));

    const onFormSubmitSuccess = () => {
        setIsLoading(false);
        dispatch(updateSupportingDocumentsDatFromStateToStore('studentIDCard', null));
        dispatch(updateSupportingDocumentsDatFromStateToStore('studentVisa', null));
        dispatch(updateSupportingDocumentsDatFromStateToStore('studentIDExpiryDate', null));
        dispatch(updateSupportingDocumentsDatFromStateToStore('studentVisaExpiryDate', null));

        if (profile?.guarantor_required) {
            dispatch(updatedOnSupportUploadedEvent(true));
        } else {
            history.push(ROUTES.ORDER_SUMMARY);
        }

        notify('Thank you! Your documents have been uploaded successfully!', notifType.SUCCESS);
    };

    const onGurantorFormSubmitSuccess = () => {
        setIsLoading(false);
        dispatch(guarantorInformationFromStateToStore('guarantorName', ''));
        dispatch(guarantorInformationFromStateToStore('guarantorRelation', ''));
        dispatch(guarantorInformationFromStateToStore('guarantorEmail', ''));
        dispatch(guarantorInformationFromStateToStore('guarantorMobile', ''));

        notify('Thank you! Your gurantor information have been updated successfully!', notifType.SUCCESS);
        history.push(ROUTES.ORDER_SUMMARY);
    };

    const onFormSubmitFailure = () => {
        setIsLoading(false);

        if (profile?.is_student) {
            if (
                (supportingDocs?.studentIDCard === null || supportingDocs?.studentIDCard === undefined) ||
                (supportingDocs?.studentIDExpiryDate === null || supportingDocs?.studentIDExpiryDate === undefined)
            ) {
                notify('Please upload the ID card and fill the ID expiry date!', notifType.DANGER);
            }
        }

        if (profile?.pass_proof_of_expiry_required) {
            if (
                (supportingDocs?.studentVisa === null || supportingDocs?.studentVisa === undefined) ||
                (supportingDocs?.studentVisaExpiryDate === null || supportingDocs?.studentVisaExpiryDate === undefined)
            ) {
                notify('Please upload the Visa copy and fill the Visa expiry date!', notifType.DANGER);
            }
        }
    };

    useEffect(() => {
        if (currentCartItemPricingObj === undefined || isEmpty(currentCartItemPricingObj)) {
            setCurrentCartItemPricingObjLocalStorage(JSON.parse(localStorage.getItem('currentCartItemPricingObj')));
        } else {
            setCurrentCartItemPricingObjLocalStorage(currentCartItemPricingObj);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCartItemPricingObj]);

    useEffect(() => {
        if (triggerPlaceOrderEvent === true && triggeringThePlaceOrderButtonEvent === true) {
            // dispatch(triggerOrderPlacingEventFromOutside(true));
            setIsOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerPlaceOrderEvent]);

    const onUnwantedItemsClearingSuccess = () => setIsLoading(false);

    const handleProceedToOrder = async (isStudent) => {
        if (!isAuthed) {
            history.push(ROUTES.SIGN_UP, { isStudent: isStudent });
        } else if (isAuthed && profile?.is_student && !profile?.emailVerified) {
            history.push(ROUTES.OTP_VERIFICATION);
        } else if (!isVerified) {
            history.push(ROUTES.SINGPASS, { isStudent: isStudent });
        } else {
            setIsLoading(true);
            const profileData = await getAuthedProfile();

            if (location.pathname === ROUTES.DOCUMENTSPROOF && !profile?.document_proof_submitted) {
                const formData = new FormData();

                if (!supportingDocsUploaded) {
                    if (profile?.is_student && !profile?.pass_proof_of_expiry_required) {
                        if (supportingDocs?.studentIDCard !== null && supportingDocs?.studentIDCard !== undefined && supportingDocs?.studentIDExpiryDate !== null && supportingDocs?.studentIDExpiryDate !== undefined) {
                            formData.append('student_id_image_url', supportingDocs?.studentIDCard);
                            formData.append('student_id_expiry_date', supportingDocs?.studentIDExpiryDate);
                            dispatch(handleSupportDocsUpload(formData, onFormSubmitSuccess, onFormSubmitFailure));
                        } else {
                            if (supportingDocs?.studentIDCard === null || supportingDocs?.studentIDCard === '' || supportingDocs?.studentIDCard === undefined) {
                                notify('Please upload the student ID card!', notifType.DANGER, 5000);
                            }

                            if (supportingDocs?.studentIDExpiryDate === null || supportingDocs?.studentIDExpiryDate === '' || supportingDocs?.studentIDExpiryDate === undefined) {
                                notify('Please update the student ID ExpiryDate!', notifType.DANGER, 5000);
                            }
                        }
                    } else if (!profile?.is_student && profile?.pass_proof_of_expiry_required) {
                        if (supportingDocs?.studentVisa !== null && supportingDocs?.studentVisa !== undefined && supportingDocs?.studentVisaExpiryDate !== null && supportingDocs?.studentVisaExpiryDate !== undefined) {
                            formData.append('visa_image_url', supportingDocs?.studentVisa);
                            formData.append('visa_expiry_date', supportingDocs?.studentVisaExpiryDate);
                            dispatch(handleSupportDocsUpload(formData, onFormSubmitSuccess, onFormSubmitFailure));
                        } else {
                            if (supportingDocs?.studentVisa === null || supportingDocs?.studentVisa === '' || supportingDocs?.studentVisa === undefined) {
                                notify('Please upload the student Visa!', notifType.DANGER, 5000);
                            }

                            if (supportingDocs?.studentVisaExpiryDate === null || supportingDocs?.studentVisaExpiryDate === '' || supportingDocs?.studentVisaExpiryDate === undefined) {
                                notify('Please update the student Visa ExpiryDate!', notifType.DANGER, 5000);
                            }
                        }
                    } else if (profile?.pass_proof_of_expiry_required && profile?.is_student) {
                        if (
                            supportingDocs?.studentVisa !== null &&
                            supportingDocs?.studentVisa !== undefined &&
                            supportingDocs?.studentVisaExpiryDate !== null &&
                            supportingDocs?.studentVisaExpiryDate !== undefined
                        ) {
                            formData.append('visa_image_url', supportingDocs?.studentVisa);
                            formData.append('visa_expiry_date', supportingDocs?.studentVisaExpiryDate);

                            dispatch(handleSupportDocsUpload(formData, onFormSubmitSuccess, onFormSubmitFailure));
                        } else {
                            if (supportingDocs?.studentVisa === null || supportingDocs?.studentVisa === '' || supportingDocs?.studentVisa === undefined) {
                                notify('Please upload the student Visa!', notifType.DANGER, 5000);
                            }

                            if (supportingDocs?.studentVisaExpiryDate === null || supportingDocs?.studentVisaExpiryDate === '' || supportingDocs?.studentVisaExpiryDate === undefined) {
                                notify('Please update the student Visa ExpiryDate!', notifType.DANGER, 5000);
                            }
                        }
                    }
                } else {
                    if (
                        guarantor?.guarantorName === null ||
                        guarantor?.guarantorName === '' ||
                        guarantor?.guarantorRelation === null ||
                        guarantor?.guarantorRelation === '' ||
                        guarantor?.guarantorEmail === null ||
                        guarantor?.guarantorEmail === '' ||
                        guarantor?.guarantor_mobile === null ||
                        guarantor?.guarantor_mobile === ''
                    ) {
                        notify('Please fill all the required fields!', notifType.DANGER, 5000);
                    } else {
                        formData.append('guarantor_name', guarantor?.guarantorName);
                        formData.append('guarantor_relation', guarantor?.guarantorRelation);
                        formData.append('guarantor_email', guarantor?.guarantorEmail);
                        formData.append('guarantor_mobile', guarantor?.guarantor_mobile);

                        dispatch(handleGuarantorInformationUpdate(formData, onGurantorFormSubmitSuccess, onFormSubmitFailure));
                    }
                }

                setIsLoading(false);
            } else if (location.pathname === ROUTES.CART) {
                setIsLoading(true);

                if (!isEmpty(selectedCartItem)) {
                    const itemToRemove = userCart.find(e => e?.product_attribute_value_id !== selectedCartItem?.product_attribute_value_id);

                    if (itemToRemove !== undefined) {
                        dispatch(handleRemoveCartItem(itemToRemove?.product_attribute_value_id, onUnwantedItemsClearingSuccess));
                    }

                    const resp = await checkoutRules();

                    if (resp?.status === 204) {
                        setIsLoading(false);

                        trackKlaviyoEvent('start-checkout', {
                            cartMeta: meta, cartItems: cartProducts
                        });

                        if (profileData?.data?.is_student) {
                            if (profileData?.data?.pass_proof_of_expiry_required) {
                                history.push(ROUTES.DOCUMENTSPROOF);
                            } else {
                                history.push(ROUTES.ORDER_SUMMARY);
                            }
                        } else {
                            if (profileData?.data?.pass_proof_of_expiry_required) {
                                if (profileData?.data?.document_proof_submitted) {
                                    history.push(ROUTES.ORDER_SUMMARY);
                                } else {
                                    history.push(ROUTES.DOCUMENTSPROOF);
                                }
                            } else {
                                history.push(ROUTES.ORDER_SUMMARY);
                            }
                        }
                    } else {
                        setIsLoading(false);
                        notify(resp?.data?.message?.message, notifType.DANGER, 5000);
                    }
                }
            } else if (location.pathname === ROUTES.ORDER_SUMMARY) {
                if (profileData?.data?.is_student) {
                    if (profileData?.data?.document_proof_submitted || !profileData?.data?.pass_proof_of_expiry_required) {
                        if (selectedMethodId === undefined || selectedMethodId === '' || selectedMethodId === null) {
                            notify('Error ! Please enter the payment method!', notifType.DANGER);
                        } else {
                            setIsOpen(true);
                        }
                    } else {
                        history.push(ROUTES.DOCUMENTSPROOF);
                    }
                } else {
                    if (profileData?.data?.pass_proof_of_expiry_required) {
                        if (profileData?.data?.document_proof_submitted) {
                            if (selectedMethodId === undefined || selectedMethodId === '' || selectedMethodId === null) {
                                notify('Error ! Please enter the payment method!', notifType.DANGER);
                            } else {
                                setIsOpen(true);
                            }
                        } else {
                            history.push(ROUTES.DOCUMENTSPROOF);
                        }
                    } else {
                        if (type !== 'rent' && type !== 'purchase') {
                            if (selectedMethodId === undefined || selectedMethodId === '' || selectedMethodId === null) {
                                notify('Error ! Please enter the payment method!', notifType.DANGER);
                            } else {
                                setIsOpen(true);
                            }
                        } else {
                            onClick();
                        }
                    }
                }

                setIsLoading(false);
            } else {
                validateCheckout(isStudent);
            }
        }
    };

    useEffect(() => {
        if (triggeringThePlaceOrderButtonEvent) {
            setTriggerPlaceOrderEvent(true);
            setIsLoading(false);
        } else {
            setTriggeringThePlaceOrderButtonEvent(false);
        }
    }, [triggeringThePlaceOrderButtonEvent]);

    const handleThePreviousRouteBeforeTheOrder = async () => {
        switch (location.pathname) {
            case ROUTES.CART:
            default:
                if (!isAuthed) {
                    history.push(ROUTES.SIGN_UP);
                }

                // eslint-disable-next-line no-case-declarations
                const previousProductPage = localStorage.getItem('previousProductPage');

                if (previousProductPage) {
                    history.push(previousProductPage);
                } else {
                    history.push(ROUTES.HOME + segmentQuery);
                }

                break;
            case ROUTES.SIGN_UP:
                history.push(ROUTES.CART);
                break;
            case ROUTES.DOCUMENTSPROOF:
                if (profile?.singpass_status !== 'verified') {
                    history.push(ROUTES.SINGPASS);
                } else if (profile?.singpass_status === 'verified') {
                    history.push(ROUTES.CART);
                }

                break;
            case ROUTES.ORDER_SUMMARY:
                if (profile?.singpass_status !== 'verified') {
                    history.push(ROUTES.SINGPASS);
                } else if (profile?.singpass_status === 'verified') {
                    if (profile?.is_student) {
                        if (profile?.pass_proof_of_expiry_required) {
                            history.push(ROUTES.DOCUMENTSPROOF);
                        } else {
                            history.push(ROUTES.CART);
                        }
                    } else {
                        if (profile?.pass_proof_of_expiry_required) {
                            if (profile?.document_proof_submitted) {
                                history.push(ROUTES.CART);
                            } else {
                                history.push(ROUTES.DOCUMENTSPROOF);
                            }
                        } else {
                            history.push(ROUTES.CART);
                        }
                    }
                }

                break;
        }
    };

    const validateCheckout = async () => {
        setIsLoading(true);
        const resp = await checkoutRules();

        if (resp?.status === 204) {
            setIsLoading(false);

            if (profile?.document_proof_submitted) {
                setTriggerPlaceOrderEvent(true);
                history.push(ROUTES.ORDER_SUMMARY);
            } else {
                history.push(ROUTES.DOCUMENTSPROOF);
            }
        } else {
            setIsLoading(false);
            notify(resp?.data?.message?.message, notifType.DANGER, 5000);
        }
    };

    const getCurrency = () => APP_CURRENCY_NAME;

    const getTotalSubscription = () => {
        let subscriptionAmount = 0;

        if (products?.length > 0) {
            if (!isEmpty(selectedCartItem) && selectedCartItem) {
                const selectedCartItemSubscription = products.filter(e => e?.product_attribute_value_id === selectedCartItem?.product_attribute_value_id)[0];

                const duration = Number(selectedCartItemSubscription?.rental_period?.duration_time);
                const subscriptionValue = selectedCartItemSubscription?.total;

                subscriptionAmount += subscriptionValue * duration;
            }
        } else if (userCart?.length > 0) {
            if (!isEmpty(selectedCartItem) && selectedCartItem) {
                const selectedCartItemSubscription = userCart.filter(e => e?.id === selectedCartItem?.id)[0];

                const duration = Number(selectedCartItemSubscription?.selectedRentalPeriod?.duration_time);
                const rentalPeriodValue = Number(selectedCartItemSubscription?.selectedRentalPeriod?.price);

                let priceImpactValue = 0;

                if (selectedCartItemSubscription?.selectedStorage?.item?.price_impact) {
                    const rentalPeriodId = selectedCartItemSubscription?.selectedRentalPeriod?.id;
                    const matchingPriceImpactValue = selectedCartItemSubscription?.selectedStorage?.item?.price_impacts.find(av => av.rental_period_id === rentalPeriodId);

                    priceImpactValue = Number(matchingPriceImpactValue?.price_impacts);
                }

                subscriptionAmount += Math.floor(rentalPeriodValue + priceImpactValue) * duration;
            }
        } else if (orderExist) {
            subscriptionAmount = order.newTotalPrice * order.newRentalPeriod.duration_time;
        }

        return subscriptionAmount > 0 ? subscriptionAmount : 0;
    };

    const getTotalSubscriptionAmount = () => {
        const cost = Number(getTotalSubscription());
        const currency = getCurrency();

        return currency + ' ' + cost?.toLocaleString('en-US');
    };

    const getMonthlyFee = () => {
        let fees = 0;
        const currency = getCurrency();

        if (products?.length > 0) {
            const product = selectedCartItem;

            fees = parseInt(product?.total).toFixed(0);
        } else if (userCart?.length > 0) {
            fees = parseInt(selectedCartItem?.total).toFixed(0);
        } else if (order?.newTotalPrice) {
            fees = order.newTotalPrice;
        }

        return currency + ' ' + fees;
    };

    const formatAmount = (amount) => {
        if (amount % 1 === 0) {
            amount = parseInt(amount, 10);
        } else {
            amount = amount.toFixed(2);
        }

        return amount;
    };

    const getCouponAmount = () => {
        let discountAmount = 0;
        const currency = getCurrency();

        if (meta.discount && meta.discount > 0) {
            discountAmount = parseFloat(meta.discount);
        } else if (order.newDiscount) {
            discountAmount = parseFloat(order.newDiscount);
        }

        return currency + ' ' + formatAmount(discountAmount);
    };

    const getTotalPayable = () => {
        const currency = getCurrency();
        let fees = 0;

        if (products?.length > 0) {
            const product = selectedCartItem;

            fees = parseInt(product?.total).toFixed(0);
        } else if (userCart?.length > 0) {
            fees = parseInt(selectedCartItem?.total).toFixed(0);
        } else if (order?.newTotalPrice) {
            fees = parseInt(order?.newTotalPrice).toFixed(0);
        }

        let discountAmount = 0;

        if (meta.discount && meta.discount > 0) {
            discountAmount = parseFloat(meta.discount);
        } else if (order.newDiscount) {
            discountAmount = parseFloat(order.newDiscount);
        }

        discountAmount = formatAmount(discountAmount);

        let totalPayableAmount = parseFloat(fees - discountAmount);

        totalPayableAmount = formatAmount(totalPayableAmount);

        return currency + ' ' + totalPayableAmount;
    };

    const getDuration = () => {
        let duration = 0;

        if (products?.length > 0) {
            const product = selectedCartItem;

            duration = product?.rental_period?.duration_time;
        } else if (userCart?.length > 0) {
            duration = currentCartItemPricingObjLocalStorage?.data?.duration_time;
        } else if (orderExist) {
            duration = order.newRentalPeriod.duration_time;
        }

        if (isExtraMonthPromo) {
            duration = duration + 1;
        }

        return duration;
    };

    const onToggle = () => setIsOpen(!isOpen);

    const placeOrder = () => {
        setIsOpen(false);
        dispatch(triggerOrderPlacingEventFromOutside(true));
    };

    const backToOrderSummary = () => setIsOpen(!isOpen);

    const getProductName = () => {
        if (selectedCartItem && !isEmpty(selectedCartItem)) {
            return selectedCartItem.name || selectedCartItem.base_product?.name;
        }

        return productName;
    };

    const getProductColorStorage = () => {
        if (selectedCartItem && !isEmpty(selectedCartItem)) {
            const colorName = selectedCartItem.color?.name ?? selectedCartItem.selectedColor?.text;
            const storageAttribute = getStorageAttribute(selectedCartItem);

            return `${colorName} | ${storageAttribute}`;
        }

        return `${productColor} | ${productStorage}`;
    };

    const getFormattedRetailPrice = () => {
        const retailValue = selectedCartItem?.base_product?.retail_value?.toLocaleString('en-US') || selectedCartItem?.retail_value?.toLocaleString('en-US');

        return `${APP_CURRENCY_NAME} ${retailValue || productRetailValue?.toLocaleString('en-US')}`;
    };

    useEffect(() => {
        if (meta.coupon) {
            setCoupon(meta.coupon);
            setCouponCode(meta.coupon);
            setCouponAmount(meta.coupon);
            setIsExtraMonthPromo(meta.discount === '0.00');
        } else if (orderExist && order.newDiscount) {
            setCoupon(order.coupon);
            setCouponCode(order.coupon);
            setCouponAmount(order.coupon);
            setIsExtraMonthPromo(order.newDiscount === '0.00');
        } else {
            setCoupon('');
            setCouponCode('');
            setCouponAmount('');
            setIsExtraMonthPromo('');
        }
    }, [meta, order, setCoupon, setCouponAmount]);

    useEffect(() => {
        const tradeInDeviceKey = localStorage.getItem(STORAGEKEY_TRADE_IN_DEVICE);

        if (tradeInDeviceKey === 'none') setSelectedTradeIn(null);
        else setSelectedTradeIn(TRADE_IN_DEVICES.find((device) => device.key === tradeInDeviceKey));
    }, []);

    useEffect(() => {
        if (orderExist) {
            const orderColorNameData = order?.variation?.product?.colors?.find(e => e.id === order.color_id);

            setProductName(order.variation.product.name);
            setProductCategory(order.variation.product.category.name);
            setProductColor(orderColorNameData.name);
            setProductStorage(order.variation.value);
            setProductRetailValue(order.variation.meta.retail_value);
        }
    }, [orderExist, order]);

    const getButtonText = (isLoading, type) => {
        if (isLoading) return <Spinner className='spinner' />;

        if (type === 'rent') {
            return 'Update';
        } else {
            return 'Next';
        }
    };

    return (
        <>
            <CheckoutPaymentInfo isOpen={isOpen} onToggle={onToggle} placeOrder={placeOrder}
                backToOrderSummary={backToOrderSummary}/>
            <div className='right_panel_container'>
                <section className='sticky__bottom'>
                    {(((selectedCartItem !== null && selectedCartItem !== undefined && !isEmpty(selectedCartItem)) && (!isMobile && !emptyCart) && (userCart?.length === 1)) || (orderExist && !isMobile)) && <>
                        <div className='product_summary'>
                            <div className='product_summary__top__header'>
                                <h6>Order Summary</h6>
                            </div>
                            <div className='product_summary__top__content'>
                                <div className='product_summary__top__content__left__content product_summary__top__content__left__content__extended'>
                                    <h6>
                                        {getProductName()}
                                    </h6>
                                    {getProductColorStorage()}
                                </div>
                            </div>
                            {(orderExist === false) &&
                            <p className='free__delivery_note'>Free delivery within 5 days of order approval</p>
                            }
                        </div>
                        <div className='cost_summary'>
                            <div className='cost_summary__top__content__left__content'>
                                <h6>Total subscription amount</h6>
                                <h6>Retail price</h6>
                            </div>
                            <div className='cost_summary__top__content__right__content'>
                                <h6>{getTotalSubscriptionAmount()}</h6>
                                <h6 className='cost_summary__top__content__right__content__strikethrough'>{getFormattedRetailPrice()}</h6>
                            </div>
                        </div>
                        <div className='subscription_summary'>
                            <div className='subscription_summary__top__content__left__content'>
                                <h6>Subscription summary</h6>
                                <h5>Monthly fee</h5>
                                {isExtraMonthPromo ? (
                                    <h6>Promo Benefit ({couponCode})</h6>
                                ) : (
                                    couponAmount && (
                                        <>
                                            <h6>Discount ({couponCode})</h6>
                                            <h5>Total Payable</h5>
                                        </>
                                    )
                                )}
                                <span className='tax-note'>Includes Tax</span>
                                <h5>For</h5>
                                {selectedTradeIn && selectedCartItem?.base_product?.category?.name === 'Smartphones' && <>
                                    <h5>Trade In Cashback
                                        <h6>Amount will be paid post Inspection</h6>
                                    </h5>
                                </>}
                            </div>
                            <div className='subscription_summary__top__content__right__content'>
                                <span>&nbsp;</span>
                                <span className='subscription_summary__top__content__right__content__price'>{getMonthlyFee() + ' / mo'}</span>
                                {isExtraMonthPromo ? (
                                    <span className='subscription_summary__top__content__right__content__couponprice'>1 month free</span>
                                ) : (
                                    couponAmount && (
                                        <>
                                            <span className='subscription_summary__top__content__right__content__couponprice'>- {getCouponAmount() + ' / mo'}</span>
                                            <span className='subscription_summary__top__content__right__content__price'>{getTotalPayable() + ' / mo'}</span>
                                        </>
                                    )
                                )}
                                <span>&nbsp;</span>
                                <span className='subscription_summary__top__content__right__content__duration'>{getDuration()} month{getDuration() !== 1 ? 's' : ''}</span>
                                {selectedTradeIn && selectedCartItem?.base_product?.category?.name === 'Smartphones' && <>
                                    <span className='subscription_summary__top__content__right__content__price'>{selectedTradeIn?.cashback}</span>
                                    <span>&nbsp;</span>
                                </>}
                            </div>
                        </div>
                        {(location.pathname === ROUTES.CART || (location.pathname === ROUTES.ORDER_SUMMARY && type === 'rent')) && <>
                            <div className='promo_code_section'>
                                <form onSubmit={handleSubmit}>
                                    <h6 className='promo_code_title'>Promo Code</h6>
                                    <div className='promo_code_input_container'>
                                        <input type='text' className='promo_code_input' name='coupon'
                                            value={coupon}
                                            onChange={(e) => setCoupon(e.target.value)} />
                                        <button className='promo_code_apply_button' onClick={handleSubmit} type='submit'
                                            disabled={Loading} >
                                            {Loading ? <Spinner className='spinner' /> : 'Apply'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>}
                    </>}
                    {(userCart?.length > 1 && !isMobile) &&
                    <div className='extraItemsNoteContainer'>
                        <p>We kindly request that you select only one item for subscription at a time. Please remove any additional items from your cart. We appreciate your understanding. Thank you.</p>
                    </div>}
                    {(isMobile && location.pathname !== ROUTES.SIGNUP) && <div className='sticky__bottom'>
                        {isEmpty(selectedCartItem) && orderExist === false
                            ? <p className='sticky__bottom__restriction__note'>We kindly request that you select only one item for subscription at a time. Please remove any additional items from your cart. We appreciate your understanding. Thank you.</p>
                            : (userCart.length > 1)
                                ? <div className='extraItemsNoteContainerStickBottom'>
                                    <p>We kindly request that you select only one item for subscription at a time. Please remove any additional items from your cart. We appreciate your understanding. Thank you.</p>
                                </div> : <>
                                    {(cartStickyBottomExpanded && selectedTradeIn && selectedCartItem?.base_product?.category?.name === 'Smartphones') && <div className='sticky__bottom__mobile trade-in-cashback'>
                                        <div className='w-100 d-flex justify-content-between'>
                                            <span className='trade-in-cashback__title'>Trade In Cashback</span>
                                            <span className='trade-in-cashback__price'>{selectedTradeIn?.cashback}</span>
                                        </div>
                                        <p className='trade-in-cashback__note'>Amount will be paid post Inspection</p>
                                    </div>}
                                    <h6 className='sticky__bottom__heading'>Order Summary</h6>
                                    <div className='sticky__bottom__mobile'>
                                        <div className='sticky__bottom__mobile__left'>
                                            <span>Monthly Fee {(localStorage.getItem('is_student') && localStorage.getItem('is_student') === 'b2s') ? '(For Students)' : ''}</span>
                                        </div>
                                        <div className='sticky__bottom__mobile__right'>
                                            <span className='sticky__bottom__mobile__right__monthly__fee'>{getMonthlyFee()}<span className='sticky__bottom__mobile__right__monthly__fee__normal__font'>&nbsp;/&nbsp;mo</span></span>
                                        </div>
                                    </div>
                                    {isExtraMonthPromo ? (
                                        <>
                                            <div className='sticky__bottom__mobile'>
                                                <div className='sticky__bottom__mobile__left sticky__bottom__mobile__left__discount'>
                                                    <span>Promo Benefit ({couponCode})</span>
                                                </div>
                                                <div className='sticky__bottom__mobile__right sticky__bottom__mobile__right__discount'>
                                                    <span className='sticky__bottom__mobile__right__monthly__fee'>+1 Month</span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        couponAmount && (
                                            <>
                                                <div className='sticky__bottom__mobile'>
                                                    <div className='sticky__bottom__mobile__left sticky__bottom__mobile__left__discount'>
                                                        <span>Discount ({coupon})</span>
                                                    </div>
                                                    <div className='sticky__bottom__mobile__right sticky__bottom__mobile__right__discount'>
                                                        <span className='sticky__bottom__mobile__right__monthly__fee'>- {getCouponAmount()}<span className='sticky__bottom__mobile__right__monthly__fee__normal__font'>&nbsp;/&nbsp;mo</span></span>
                                                    </div>
                                                </div>
                                                <div className='sticky__bottom__mobile'>
                                                    <div className='sticky__bottom__mobile__left sticky__bottom__mobile__left__discount'>
                                                        <span>Total Payable</span>
                                                    </div>
                                                    <div className='sticky__bottom__mobile__right sticky__bottom__mobile__right__discount'>
                                                        <span className='sticky__bottom__mobile__right__monthly__fee'>{getTotalPayable()}<span className='sticky__bottom__mobile__right__monthly__fee__normal__font'>&nbsp;/&nbsp;mo</span></span>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    )}
                                    {cartStickyBottomExpanded && <div className='sticky__bottom__mobile__content'>
                                        <h6>{getProductName()}</h6>
                                        {getProductColorStorage()}
                                    </div>}
                                    {cartStickyBottomExpanded && <div className='sticky__bottom__mobile'>
                                        <div className='sticky__bottom__mobile__left'>
                                            <span className='sticky__bottom__mobile__left__for'>For</span>
                                        </div>
                                        <div className='sticky__bottom__mobile__right'>
                                            <span className='sticky__bottom__mobile__right__duration'>{getDuration()} month{getDuration() !== 1 ? 's' : ''}</span>
                                        </div>
                                    </div>}
                                </>}
                    </div>}
                    {(!hideBottomCTABtns && (!emptyCart || orderExist) && location.pathname !== ROUTES.SIGNUP) &&
                        <div className='cta_buttons'>
                            <button
                                onClick={handleThePreviousRouteBeforeTheOrder}>
                                Back
                            </button>
                            {(location.pathname === ROUTES.DOCUMENTSPROOF)
                                ? (!supportingDocsUploaded)
                                    ? <button
                                        onClick={() => handleProceedToOrder(true)}
                                        disabled={isLoading || emptyCart}>
                                        {getButtonText(isLoading, type)}
                                    </button>
                                    : <button
                                        onClick={() => handleProceedToOrder(true)}
                                        disabled={isLoading || emptyCart || guarantor?.guarantorName === '' || guarantor?.guarantorRelation === '' || guarantor?.guarantorEmail === '' || guarantor?.guarantorMobile === ''}>
                                        {getButtonText(isLoading, type)}
                                    </button>
                                : <button onClick={() => handleProceedToOrder(true)}
                                    disabled={(isLoading || userCart.length > 1 || emptyCart || selectedCartItem === undefined || selectedCartItem === null || isEmpty(selectedCartItem))}>
                                    {getButtonText(isLoading, type)}
                                </button>}
                        </div>}
                    {(hideBottomCTABtns && ((!emptyCart && userCart.length > 0) || orderExist) && location.pathname === ROUTES.ORDER_SUMMARY && isMobile && orderPlaced === false) &&
                    <div className='cta_buttons'>
                        <button
                            onClick={handleThePreviousRouteBeforeTheOrder}>
                            Back
                        </button>
                        <button
                            onClick={() => handleProceedToOrder(true)}
                            disabled={(emptyCart && orderExist === false) || (
                                orderPlacementPageTermsAndCondition === false ||
                                orderPlacementPageTermsAndCondition === undefined ||
                                isLoading
                            )}>
                            {getButtonText(isLoading, type)}
                        </button>
                    </div>}
                    <div className='bottom_buttons'>
                        {(emptyCart && userCart.length === 0 && orderExist === false) && (<p>*Your cart is empty. Please add at least one item in the cart.</p>)}
                    </div>
                    {((selectedCartItem !== null && selectedCartItem !== undefined && userCart?.length === 1) || orderExist) && <p className='sticky__bottom__final__note'>By Submitting your order, you agree to the <a className='' href={ROUTES.TERMS_AND_CONDITIONS} target='_blank'
                        rel='noreferrer'>Terms of Service</a>, <a className='' href={ROUTES.TERMS_AND_CONDITIONS} target='_blank'
                        rel='noreferrer'>Terms of Use</a> and we will use your personal data in accordance with our <a href={ROUTES.PRIVACY_POLICY} target='_blank'
                        rel='noreferrer'>Privacy policy</a>.</p>}
                </section>
            </div>
        </>
    );
};

ToProceed.propTypes = {
    products: PropTypes.array,
    userCart: PropTypes.array,
    hideBottomCTABtns: PropTypes.bool,
    cartStickyBottomExpanded: PropTypes.bool,
    form: PropTypes.string,
    triggerLoginSubmit: PropTypes.func,
    triggerRegistrationSubmit: PropTypes.func,
    coupon: PropTypes.string,
    setCoupon: PropTypes.func,
    submitCoupon: PropTypes.func,
    handleSubmit: PropTypes.func,
    Loading: PropTypes.bool,
    order: PropTypes.array,
    orderExist: PropTypes.bool,
    type: PropTypes.string,
    onClick: PropTypes.func
};

export default ToProceed;
